import * as React from 'react';
import { IAreaPart, IBargainTermsSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getIsAnnual, getIsRent, getPrice, getPriceOfMeter } from '../../utils/areaParts';
import * as styles from './AreaParts.css';

export interface IAreaPartsProps {
  areaParts?: IAreaPart[];
  bargainTerms: IBargainTermsSchema;
}

export function AreaParts({ areaParts, bargainTerms }: IAreaPartsProps) {
  if (areaParts && areaParts.length > 0) {
    let areaPartsView;
    const { priceType, paymentPeriod } = bargainTerms;

    areaPartsView = areaParts.map((area, index) => {
      const isRent = getIsRent(paymentPeriod || '');
      const isAnnual = getIsAnnual(paymentPeriod || '');
      const price = getPrice(isAnnual, isRent, priceType, paymentPeriod || '', area);
      const priceOfMeter = getPriceOfMeter(isAnnual, isRent, priceType, paymentPeriod || '', area);

      return (
        <div key={`offer-area-part-${index}`} className={styles['area-part']}>
          <div className={styles['row']}>
            <div className={styles['area']}>{area.area} м²</div>
            <div className={styles['prices']}>
              <div className={styles['price-of-meter']}>{priceOfMeter}</div>
              <div className={styles['price']}>{price}</div>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div>
        <div className={styles['area-parts-title']}>Доступные площади</div>
        <div className={styles['area-parts-list']}>{areaPartsView}</div>
      </div>
    );
  }

  return null;
}
